export default __webpack_public_path__ + "static/media/SilvanoWestern-Regular.50144b23.otf";